import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getClients } from '../../actions/Clients';
import {
  Paper,
  CircularProgress,
  AppBar,
  IconButton,
  Drawer,
} from 'material-ui';
import ClientsList from '../../components/ClientsList';
import FilterClientsStatus from '../../components/FilterClientsStatus';
import ContentClear from 'material-ui/svg-icons/content/clear';
import Header from '../Bar/Header';

const styles = {
  loader: {
    position: 'fixed',
    bottom: 16,
    right: 16,
  },
  list: {
    margin: 8,
    padding: 8,
  },
};

class Clients extends Component {
  static propTypes = {
    clients: PropTypes.object,
    getClients: PropTypes.func,
    loading: PropTypes.bool,
    children: PropTypes.node,
  };

  static defaultProps = {
    clientsPerPage: 30,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  state = {
    pageStart: 0,
    pageEnd: 30,
    filters: [],
    open: false,
    searchText: '',
  };

  componentDidMount() {
    const { getClients, clientsPerPage } = this.props;
    const { pageStart, filters } = this.state;
    this._node = document.body;
    getClients(filters, pageStart, clientsPerPage);
    window.addEventListener('scroll', this.onPageScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onPageScroll);
  }

  onChooseClient = (client) => {
    const { router } = this.context;
    router.push(`/clients/${client.id}`);
  };

  onPageScroll = () => {
    const clientScrollHeight = window.innerHeight + window.scrollY;
    const windowBottomHeight = document.documentElement.offsetHeight;
    if (clientScrollHeight >= windowBottomHeight) {
      this.loadNext();
    }
  };

  loadNext() {
    const { getClients, clientsPerPage } = this.props;
    const { filters, pageStart, pageEnd } = this.state;

    this.setState(
      {
        pageStart: 0,
        pageEnd: pageEnd + clientsPerPage,
      },
      () => {
        getClients(filters, pageStart, this.state.pageEnd);
      }
    );
  }

  filter() {
    const { getClients, clientsPerPage } = this.props;
    const { filters } = this.state;

    getClients(filters, 0, clientsPerPage);
  }

  handleFilter = (status, searchText) => {
    let filters = [];

    if (status === 'active') {
      filters.push({ mode: 'status', value: 1 });
    } else if (status === 'inactive') {
      filters.push({ mode: 'status', value: 0 });
    }

    if (searchText) {
      filters.push({
        mode: Number.isInteger(Number(searchText)) ? 'clientId' : 'email',
        value: searchText,
      });
    }

    this.setState(
      {
        searchText,
        filters,
        pageEnd: this.props.clientsPerPage,
      },
      () => {
        this.filter();
      }
    );
  };

  handleToggle = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { pageEnd } = this.state;
    const { clients, loading, children } = this.props;

    return (
      <div>
        <Header title="Clients" />

        {clients && Object.keys(clients).length <= pageEnd
          ? loading && (
          <div style={styles.loader}>
            <CircularProgress />
          </div>
        )
          : null}

        <Drawer openSecondary={true} open={this.state.open}>
          <AppBar
            title="Close"
            onClick={this.handleToggle}
            iconElementLeft={
              <IconButton>
                <ContentClear />
              </IconButton>
            }
          />
        </Drawer>

        <div
          style={{
            display: 'flex',
            alignItems: 'stretch',
            marginTop: 60,
            marginLeft: 8,
            marginRight: 8,
          }}
        >
          <div style={{ flex: 1 }}>
            <FilterClientsStatus onChange={this.handleFilter} />
            <ClientsList
              onChooseClient={this.onChooseClient}
              clients={clients}
            />
          </div>

          {children && (
            <Paper style={{ flex: 1, margin: 18 }}>{children}</Paper>
          )}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    getClients: bindActionCreators(getClients, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    clients: state.clientsReducer.clients,
    loading: state.clientsReducer.loading,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
